import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-6135d99c")
const _hoisted_1 = { class: "card card-flush w-100 p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header px-6 py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Picking Jobs")
  ])
], -1)
const _hoisted_3 = { class: "card-body p-6 px-0 table-container" }
const _hoisted_4 = { class: "table-header-wrapper overflow-hidden" }
const _hoisted_5 = {
  key: 0,
  class: "table-header-left",
  id: "table-header-left"
}
const _hoisted_6 = {
  key: 0,
  id: "table-header-checkbox-column",
  class: "\n                            header-column\n                            h6\n                            position-relative\n                            d-flex\n                            justify-content-center\n                            align-items-center\n                        "
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "h6 header-cell-text overflow-visible" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "form-check p-0" }, [
    /*#__PURE__*/_createElementVNode("input", {
      class: "form-check-input m-0",
      type: "checkbox",
      value: "",
      id: "flexCheckDefault"
    })
  ])
], -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = ["id"]
const _hoisted_10 = { class: "h6 header-cell-text" }
const _hoisted_11 = { class: "\n                                    position-absolute\n                                    top-0\n                                    start-0\n                                    w-100\n                                    h-100\n                                    cursor-pointer\n                                " }
const _hoisted_12 = { class: "position-relative w-100 h-100" }
const _hoisted_13 = ["onMousedown"]
const _hoisted_14 = ["id"]
const _hoisted_15 = ["id"]
const _hoisted_16 = { class: "h6 header-cell-text me-3" }
const _hoisted_17 = { class: "\n                                    position-absolute\n                                    top-0\n                                    start-0\n                                    w-100\n                                    h-100\n                                    cursor-pointer\n                                " }
const _hoisted_18 = { class: "position-relative w-100 h-100" }
const _hoisted_19 = ["onMousedown"]
const _hoisted_20 = ["id"]
const _hoisted_21 = {
  key: 1,
  class: "table-header-right",
  id: "table-header-right"
}
const _hoisted_22 = ["id"]
const _hoisted_23 = { class: "h6 header-cell-text" }
const _hoisted_24 = { class: "\n                                    position-absolute\n                                    top-0\n                                    start-0\n                                    w-100\n                                    h-100\n                                    cursor-pointer\n                                " }
const _hoisted_25 = { class: "position-relative w-100 h-100" }
const _hoisted_26 = ["onMousedown"]
const _hoisted_27 = ["id"]
const _hoisted_28 = {
  class: "table-body-wrapper position-relative",
  id: "table-body-wrapper"
}
const _hoisted_29 = { class: "table-row-portion-left" }
const _hoisted_30 = { class: "form-check p-0" }
const _hoisted_31 = ["value", "v-model"]
const _hoisted_32 = { class: "table-row-portion-right" }
const _hoisted_33 = { class: "table-footer" }
const _hoisted_34 = { class: "custom-table-footer" }
const _hoisted_35 = {
  class: "\n                        rows-per-page-select\n                        btn\n                        dropdown-toggle\n                        mo-dropdown-button\n                    ",
  type: "button",
  id: "rows-per-page-select",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_36 = {
  class: "dropdown-menu px-3 py-0",
  "aria-labelledby": "rows-per-page-select"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-0" }, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "separator mt-3 opacity-0" }, null, -1)
const _hoisted_39 = { class: "paginator-container" }
const _hoisted_40 = { class: "paginator-buttons" }
const _hoisted_41 = ["onClick"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_ctx.frozenLeft + 1 > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_ctx.isCheckboxesEnabled)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (header, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                  (_ctx.isFrozenLeft(index, header))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: header + index,
                        class: "header-column h6",
                        id: 'header-' + header,
                        style: _normalizeStyle([
                                'width: ' +
                                    String(_ctx.tableOptions[header]['width']) +
                                    'px',
                                'max-width: ' +
                                    String(_ctx.tableOptions[header]['width']) +
                                    'px',
                                'order: ' + _ctx.tableOptions[header]['order'],
                            ])
                      }, [
                        _createElementVNode("div", _hoisted_10, _toDisplayString(header), 1),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_inline_svg, {
                              src: `${_ctx.originUrl}/assets/svg/icons/symbols/triangle.svg`,
                              class: "\n                                            position-absolute\n                                            end-0\n                                            top-50\n                                            me-1\n                                            sort-svg\n                                        "
                            }, null, 8, ["src"])
                          ])
                        ]),
                        _createElementVNode("div", {
                          onMousedown: ($event: any) => (
                                    _ctx.handleRightResizeMouseDown($event, header)
                                ),
                          class: "\n                                    resize-bar\n                                    position-absolute\n                                    top-50\n                                    start-100\n                                    translate-middle\n                                "
                        }, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", {
                              id: 'resize-bar-' + header
                            }, null, 8, _hoisted_14)
                          ])
                        ], 40, _hoisted_13)
                      ], 12, _hoisted_9))
                    : _createCommentVNode("", true)
                ], 64))
              }), 256))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "table-header",
          id: "table-header",
          style: _normalizeStyle([
                        'paddingLeft: ' + String(_ctx.totalPaddingLeft) + 'px',
                        'paddingRight: ' + String(_ctx.totalPaddingRight) + 'px',
                    ])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (header, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (
                                !_ctx.isFrozenLeft(index, header) &&
                                !_ctx.isFrozenRight(index, header)
                            )
                ? (_openBlock(), _createElementBlock("div", {
                    key: header + index,
                    class: "header-column h6 position-relative",
                    id: 'header-' + header,
                    style: _normalizeStyle([
                                'width: ' +
                                    String(_ctx.tableOptions[header]['width']) +
                                    'px',
                                'max-width: ' +
                                    String(_ctx.tableOptions[header]['width']) +
                                    'px',
                                'order: ' + _ctx.tableOptions[header]['order'],
                            ])
                  }, [
                    _createElementVNode("div", _hoisted_16, _toDisplayString(header), 1),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_inline_svg, {
                          src: `${_ctx.originUrl}/assets/svg/icons/symbols/triangle.svg`,
                          class: "\n                                            position-absolute\n                                            end-0\n                                            top-50\n                                            me-1\n                                            sort-svg\n                                        "
                        }, null, 8, ["src"])
                      ])
                    ]),
                    _createElementVNode("div", {
                      onMousedown: ($event: any) => (
                                    _ctx.handleRightResizeMouseDown($event, header)
                                ),
                      class: "\n                                    resize-bar\n                                    position-absolute\n                                    top-50\n                                    start-100\n                                    translate-middle\n                                "
                    }, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", {
                          id: 'resize-bar-' + header
                        }, null, 8, _hoisted_20)
                      ])
                    ], 40, _hoisted_19)
                  ], 12, _hoisted_15))
                : _createCommentVNode("", true)
            ], 64))
          }), 256))
        ], 4),
        (_ctx.frozenRight > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (header, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                  (_ctx.isFrozenRight(index, header))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: header + index,
                        class: "header-column h6 position-relative",
                        id: 'header-' + header,
                        style: _normalizeStyle([
                                'width: ' +
                                    String(_ctx.tableOptions[header]['width']) +
                                    'px',
                                'max-width: ' +
                                    String(_ctx.tableOptions[header]['width']) +
                                    'px',
                                'order: ' + _ctx.tableOptions[header]['order'],
                            ])
                      }, [
                        _createElementVNode("div", _hoisted_23, _toDisplayString(header), 1),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _createVNode(_component_inline_svg, {
                              src: `${_ctx.originUrl}/assets/svg/icons/symbols/triangle.svg`,
                              class: "\n                                            position-absolute\n                                            end-0\n                                            top-50\n                                            me-1\n                                            sort-svg\n                                        "
                            }, null, 8, ["src"])
                          ])
                        ]),
                        _createElementVNode("div", {
                          onMousedown: ($event: any) => (
                                    _ctx.handleLeftResizeMouseDown($event, header)
                                ),
                          class: "\n                                    resize-bar\n                                    position-absolute\n                                    top-50\n                                    start-0\n                                    translate-middle\n                                "
                        }, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", {
                              id: 'resize-bar-' + header
                            }, null, 8, _hoisted_27)
                          ])
                        ], 40, _hoisted_26)
                      ], 12, _hoisted_22))
                    : _createCommentVNode("", true)
                ], 64))
              }), 256))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", {
          class: "table-body",
          id: "table-body",
          style: _normalizeStyle([
                        'margin-top: ' + String(_ctx.cellsMarginTop) + 'px',
                        'margin-bottom: ' + String(_ctx.cellsMarginBottom) + 'px',
                    ])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listOriginal.slice(
                            _ctx.renderCellsIndexFrom,
                            _ctx.renderCellsIndexTo + 1
                        ), (row, rowIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              key: row + String(rowIndex),
              class: "table-row",
              style: _normalizeStyle([
                            { minHeight: String(_ctx.tableRowHeight) + 'px' },
                            { maxHeight: String(_ctx.tableRowHeight) + 'px' },
                        ])
            }, [
              _createElementVNode("div", _hoisted_29, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell, cellIndex) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (
                                        _ctx.isFrozenLeft(
                                            cellIndex,
                                            _ctx.headers[cellIndex]
                                        ) && _ctx.isCheckboxesEnabled
                                    )
                      ? (_openBlock(), _createElementBlock("div", {
                          key: cell + cellIndex + 2,
                          class: "\n                                        table-cell\n                                        overflow-visible\n                                        d-flex\n                                        justify-content-center\n                                        align-items-center\n                                    "
                        }, [
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("input", {
                              class: "form-check-input m-0",
                              type: "checkbox",
                              value: 
                                                'table-checkbox-row-' + rowIndex
                                            ,
                              "v-model": _ctx.checksModel[rowIndex],
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (
                                                _ctx.handleTableBodyCheckboxChange(
                                                    $event
                                                )
                                            ))
                            }, null, 8, _hoisted_31)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (
                                        _ctx.isFrozenLeft(
                                            cellIndex,
                                            _ctx.headers[cellIndex]
                                        )
                                    )
                      ? (_openBlock(), _createElementBlock("div", {
                          key: cell + cellIndex + 1,
                          class: "table-cell",
                          style: _normalizeStyle([
                                        'width: ' +
                                            String(
                                                _ctx.tableOptions[
                                                    _ctx.headers[cellIndex]
                                                ]['width']
                                            ) +
                                            'px',
                                        'max-width: ' +
                                            String(
                                                _ctx.tableOptions[
                                                    _ctx.headers[cellIndex]
                                                ]['width']
                                            ) +
                                            'px',
                                    ])
                        }, _toDisplayString(cell), 5))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 256))
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell, cellIndex) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                  (
                                    !_ctx.isFrozenLeft(
                                        cellIndex,
                                        _ctx.headers[cellIndex]
                                    ) &&
                                    !_ctx.isFrozenRight(
                                        cellIndex,
                                        _ctx.headers[cellIndex]
                                    )
                                )
                    ? (_openBlock(), _createElementBlock("div", {
                        key: cell + cellIndex + 3,
                        class: "table-cell",
                        style: _normalizeStyle([
                                    'width: ' +
                                        String(
                                            _ctx.tableOptions[_ctx.headers[cellIndex]][
                                                'width'
                                            ]
                                        ) +
                                        'px',
                                    'max-width: ' +
                                        String(
                                            _ctx.tableOptions[_ctx.headers[cellIndex]][
                                                'width'
                                            ]
                                        ) +
                                        'px',
                                ])
                      }, _toDisplayString(cell), 5))
                    : _createCommentVNode("", true)
                ], 64))
              }), 256)),
              _createElementVNode("div", _hoisted_32, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell, cellIndex) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (
                                        _ctx.isFrozenRight(
                                            cellIndex,
                                            _ctx.headers[cellIndex]
                                        )
                                    )
                      ? (_openBlock(), _createElementBlock("div", {
                          key: cell + cellIndex + 2,
                          class: "table-cell",
                          style: _normalizeStyle([
                                        'width: ' +
                                            String(
                                                _ctx.tableOptions[
                                                    _ctx.headers[cellIndex]
                                                ]['width']
                                            ) +
                                            'px',
                                        'max-width: ' +
                                            String(
                                                _ctx.tableOptions[
                                                    _ctx.headers[cellIndex]
                                                ]['width']
                                            ) +
                                            'px',
                                    ])
                        }, _toDisplayString(cell), 5))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 256))
              ])
            ], 4))
          }), 128))
        ], 4)
      ])
    ]),
    _createElementVNode("div", _hoisted_33, [
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("button", _hoisted_35, _toDisplayString(_ctx.paginatorPageSize), 1),
        _createElementVNode("ul", _hoisted_36, [
          _hoisted_37,
          _createElementVNode("li", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setPaginatorPageSize(50))),
            class: "\n                            dropdown-item\n                            metronic-dropdown-item\n                            ms-0\n                            mt-0\n                            cursor-pointer\n                        "
          }, " 50 "),
          _createElementVNode("li", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setPaginatorPageSize(100))),
            class: "\n                            dropdown-item\n                            metronic-dropdown-item\n                            ms-0\n                            cursor-pointer\n                        "
          }, " 100 "),
          _createElementVNode("li", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setPaginatorPageSize(150))),
            class: "\n                            dropdown-item\n                            metronic-dropdown-item\n                            ms-0\n                            cursor-pointer\n                        "
          }, " 150 "),
          _createElementVNode("li", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setPaginatorPageSize(200))),
            class: "\n                            dropdown-item\n                            metronic-dropdown-item\n                            ms-0\n                            cursor-pointer\n                        "
          }, " 200 "),
          _createElementVNode("li", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setPaginatorPageSize(250))),
            class: "\n                            dropdown-item\n                            metronic-dropdown-item\n                            ms-0\n                            mb-0\n                            cursor-pointer\n                        "
          }, " 250 "),
          _hoisted_38
        ]),
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("button", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.previousPaginatorPage())),
              type: "button",
              class: "btn mx-2"
            }, " ← "),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getPaginatorButtons(), (btn) => {
              return (_openBlock(), _createElementBlock("button", {
                key: String(btn),
                onClick: ($event: any) => (_ctx.setPaginatorPage(btn)),
                type: "button",
                class: _normalizeClass(["btn mx-2", [
                                _ctx.getIsCurrentPaginatorButton(btn)
                                    ? 'blue-button'
                                    : '',
                            ]])
              }, _toDisplayString(btn), 11, _hoisted_41))
            }), 128)),
            _createElementVNode("button", {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.nextPaginatorPage())),
              type: "button",
              class: "btn mx-2"
            }, " → ")
          ])
        ])
      ])
    ])
  ]))
}